export interface SlideData {
	/**
	 * Key of the slide in `info-modal.json`.
	 *
	 * Usually `slide-X`.
	 */
	i18n: string;

	/**
	 * Name of the image of the slide **without the `/assets/images/...`**.
	 *
	 * Just the filename.
	 */
	imageName: string;

	videoId?: string;

	/**
	 * Default: `true`.
	 */
	showCross?: boolean;

	/**
	 * Default: `true`.
	 */
	closeOnOutsideClick?: boolean;
}

export interface ModalData {
	slides: SlideData[];

	/**
	 * Key on the `info-modal.json` i18n file.
	 */
	i18nName: string;
}
